import * as React from "react";
import { FilterLiveSearch, useTranslate } from 'react-admin';

export default (props) => {
    const t = useTranslate();

    return (
        <FilterLiveSearch source="userEmail" label={t('components.list_filters.userEmail', { _: 'E-mail' })} />
    )
};